import React from 'react';

const GroupDetailsHeader = () => {
    return(
        <>
        <tr>
            <th>Account name</th>
            <th>Account number</th>
            <th>NOP</th>
        </tr>
        </>
    )
}

export default GroupDetailsHeader